<template>
  <div id="grain"></div>
  <div id="vignette"></div>
  <div id="calm-wash"></div>
  <div id="panic-tint"></div>
  <div id="scanlines"></div>
  <div id="door-shadow"></div>
  <div id="flash"></div>
  <div id="progress"></div>

  <div id="fs-confirm" class="hidden" role="alertdialog" aria-modal="true" aria-labelledby="fs-confirm-text">
    <div class="fs-confirm-box">
      <p id="fs-confirm-text">Vous êtes sûr ?<br>Vous avez éteint la lumière ?<br><em>...ne regardez pas trop derrière vous.</em></p>
      <div class="fs-confirm-actions">
        <button id="fs-confirm-yes" class="fs-confirm-btn fs-confirm-yes" type="button">j'y vais</button>
        <button id="fs-confirm-no" class="fs-confirm-btn fs-confirm-no" type="button">non, pas envie</button>
      </div>
      <p id="fs-confirm-loading" class="fs-confirm-loading">la porte s'ouvre<span class="fs-dots"><span>.</span><span>.</span><span>.</span></span></p>
    </div>
  </div>

  <div id="phone-notif" class="hidden" tabindex="0" role="button" aria-label="Ouvrir la notification">
    <span class="phone-notif-avatar"></span>
    <div class="phone-notif-text">
      <div class="phone-notif-head"><span>Photos</span><span>à l'instant</span></div>
      <div class="phone-notif-body"></div>
      <div class="phone-notif-sub">expéditeur inconnu</div>
    </div>
  </div>

  <div id="reveal-overlay" class="hidden">
    <img id="reveal-img" src="/img/notification.png" alt="Elle, debout derrière lui, devant l'ordinateur." />
    <div id="reveal-vignette"></div>
    <p id="reveal-caption"></p>
  </div>

  <div id="computer-ui" class="hidden">
    <div class="cu-scan"></div>
    <div class="cu-frame">
      <div class="cu-topbar"><span class="cu-dot"></span><span class="cu-label">SYSTÈME</span></div>
      <p id="cu-text" class="cu-text"></p>
    </div>
  </div>

  <div id="bpm-meter" aria-hidden="true">
    <span class="bpm-pulse-dot"></span>
    <span id="bpm-value">68</span>
    <span class="bpm-label">bpm</span>
  </div>

  <button id="sound-toggle" type="button" aria-label="Activer le son" aria-pressed="false">♪</button>
  <button id="pause-toggle" type="button" aria-label="Mettre en pause" aria-pressed="false">⏸</button>
  <button id="skip-toggle" type="button" aria-label="Afficher la frise pour avancer" aria-pressed="false">⏭</button>

  <div id="pause-overlay">
    <p class="pause-label">pause</p>
  </div>

  <div id="seek-bar" role="slider" tabindex="0" aria-label="Avancer dans le récit" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
    <div id="seek-fill"></div>
    <div id="seek-handle"></div>
  </div>

  <main id="stage">
    <section id="start" class="panel">
      <p class="eyebrow">fiction interactive</p>
      <h1>Elle. Elle est là.</h1>
      <p class="meta">8 minutes · casque conseillé</p>
      <div class="start-actions">
        <button id="fullscreen-start" class="cta" type="button">
          <span class="cta-icon" aria-hidden="true">⤢</span>
          <span class="cta-label">plein écran</span>
          <span class="cta-tag">recommandé</span>
        </button>
        <button id="plain-start" class="enter-plain" type="button">continuer sans plein écran</button>
      </div>
      <p class="warn">contient du texte qui clignote et des variations de lumière. le son est optionnel. l'expérience est bien plus immersive en plein écran.</p>
      <p class="credits">par Alexis Mayeur</p>
    </section>

    <p id="beat" aria-live="polite"></p>

    <section id="enigma" class="panel hide">
      <p class="eyebrow">l'ordinateur t'interroge</p>
      <div class="enigma-q" data-q="0">
        <h2>Qui est-elle ?</h2>
        <div class="enigma-options">
          <button class="opt" type="button" data-correct="true">Léa</button>
          <button class="opt" type="button">Une intelligence du site</button>
          <button class="opt" type="button">Toi-même, dans une autre boucle</button>
          <button class="opt" type="button">Personne — un rêve</button>
        </div>
      </div>
      <div class="enigma-q hide" data-q="1">
        <h2>Combien de fois la boucle s'est-elle répétée avant cette nuit ?</h2>
        <div class="enigma-options">
          <button class="opt" type="button">4</button>
          <button class="opt" type="button" data-correct="true">17</button>
          <button class="opt" type="button">100</button>
          <button class="opt" type="button">On ne sait pas</button>
        </div>
      </div>
      <p class="enigma-feedback" aria-live="polite"></p>
    </section>

    <section id="end" class="panel hide">
      <p id="end-verdict" class="end-verdict"></p>
      <div class="eyes"><span class="eye"></span><span class="eye"></span></div>
      <p id="end-detail" class="end-detail"></p>
      <button class="replay" type="button">· rejouer ·</button>
    </section>
  </main>

  <p id="hint">cliquer pour continuer</p>
</template>

<script>
import BEATS_DATA from './data/beats.js'

export default {
  name: 'App',
  mounted () {
    ;(function () {
      'use strict'

      var BEATS = BEATS_DATA
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      var root = document.documentElement
      var stage = document.getElementById('stage')
      var startPanel = document.getElementById('start')
      var endPanel = document.getElementById('end')
      var beatEl = document.getElementById('beat')
      var flashEl = document.getElementById('flash')
      var progressEl = document.getElementById('progress')
      var hintEl = document.getElementById('hint')
      var doorShadow = document.getElementById('door-shadow')
      var soundBtn = document.getElementById('sound-toggle')
      var replayBtn = endPanel.querySelector('.replay')
      var fullscreenBtn = document.getElementById('fullscreen-start')
      var plainBtn = document.getElementById('plain-start')
      var fsConfirm = document.getElementById('fs-confirm')
      var fsConfirmYes = document.getElementById('fs-confirm-yes')
      var fsConfirmNo = document.getElementById('fs-confirm-no')
      var fsConfirmLoading = document.getElementById('fs-confirm-loading')
      var phoneNotif = document.getElementById('phone-notif')
      var phoneNotifBody = phoneNotif.querySelector('.phone-notif-body')
      var skipToggle = document.getElementById('skip-toggle')
      var pauseToggle = document.getElementById('pause-toggle')
      var seekBar = document.getElementById('seek-bar')
      var seekFill = document.getElementById('seek-fill')
      var seekHandle = document.getElementById('seek-handle')
      var enigmaPanel = document.getElementById('enigma')
      var enigmaQuestions = Array.prototype.slice.call(enigmaPanel.querySelectorAll('.enigma-q'))
      var enigmaFeedback = enigmaPanel.querySelector('.enigma-feedback')
      var endVerdict = document.getElementById('end-verdict')
      var endDetail = document.getElementById('end-detail')
      var revealOverlay = document.getElementById('reveal-overlay')
      var revealCaption = document.getElementById('reveal-caption')
      var computerUI = document.getElementById('computer-ui')
      var cuText = document.getElementById('cu-text')
      var bpmMeter = document.getElementById('bpm-meter')
      var bpmValueEl = document.getElementById('bpm-value')

      // lines that trigger a hard flash + shake (isolated jump-scare beats)
      var JOLT = new Set([
        'COURS.',
        'MAINTENANT, TU PEUX REGARDER.',
        'Je hurlai.',
        'Les lumières s\'éteignirent.',
        'Elle se tenait devant moi.',
        'Une femme se tenait derrière moi.',
        'Je lâchai mon téléphone.',
        '« Enfin. »',
        'La respiration s\'arrêta.',
        'ELLE SAIT QUE TU LA REGARDES.',
        'Quelque chose entra dans la pièce.',
        '« Tu n\'es pas censé t\'en souvenir. »',
        'Deux yeux qui me fixaient directement.',
        'Et un sourire.'
      ])
      // lines that hold a beat longer, for suspense
      var LONG_HOLD = new Set([
        'Le noir complet.',
        'L\'écran était noir.',
        'L\'écran devint noir.',
        'Rien.',
        'Silencieuse.',
        'Encore plus près.'
      ])
      // lines where the shadow-under-the-door motif appears
      var SHOW_SHADOW = new Set([
        'Mais quelque chose se trouvait sous la porte.',
        'Une ombre.',
        'Cette ombre.',
        'Et sous la porte...'
      ])
      var HIDE_SHADOW = new Set([
        'Mais l\'ombre sous la porte avait disparu.',
        'L\'ordinateur écrivit une dernière phrase.'
      ])
      var FACE_SHADOW = new Set([
        'Juste un visage.',
        'Plaqué contre l\'autre côté.',
        'Deux yeux qui me fixaient directement.',
        'Et un sourire.',
        'MAINTENANT, TU PEUX REGARDER.'
      ])

      var i = -1
      var timer = null
      var phoneTimer = null
      var typing = false
      var phase = 'idle' // idle | revealing | holding | dismissing | done
      var started = false
      var awaitingPhone = false
      var seekDragging = false
      var enigmaIndex = 0
      var enigmaScore = 0
      var enigmaTimer = null
      var panicking = false
      var calming = false
      var joltCleanupTimer = null
      var paused = false
      var pendingFn = null
      var pendingDelay = 0
      var pendingStart = 0
      var tensionValue = 0
      var displayBpm = 66
      var bpmInterval = null
      var bpmSpikeUntil = 0

      function setTension (t) {
        if (calming) t = Math.min(t, 0.04)
        tensionValue = t
        root.style.setProperty('--tension', t.toFixed(3))
        var hb = 1.2 - t * 0.68
        if (panicking) hb = Math.min(hb, 0.42)
        root.style.setProperty('--heartbeat-dur', hb.toFixed(2) + 's')
      }

      function wordCount (s) {
        return (s.match(/[^\s]+/g) || []).length
      }

      function clearTimer () {
        if (timer) { clearTimeout(timer); timer = null }
      }

      function setStoryTimeout (fn, delay) {
        clearTimer()
        pendingFn = fn
        pendingDelay = delay
        pendingStart = Date.now()
        timer = setTimeout(fn, delay)
      }

      function pauseGame () {
        if (paused || !started || phase === 'done') return
        paused = true
        if (timer) {
          pendingDelay = Math.max(30, pendingDelay - (Date.now() - pendingStart))
          clearTimer()
        } else {
          pendingFn = null
        }
        if (phoneTimer) { clearTimeout(phoneTimer); phoneTimer = null }
        if (enigmaTimer) { clearTimeout(enigmaTimer); enigmaTimer = null }
        if (bpmInterval) { clearInterval(bpmInterval); bpmInterval = null }
        document.body.classList.add('paused')
        pauseToggle.setAttribute('aria-pressed', 'true')
        pauseToggle.textContent = '▶'
        Sound.pause()
      }

      function resumeGame () {
        if (!paused) return
        paused = false
        document.body.classList.remove('paused')
        pauseToggle.setAttribute('aria-pressed', 'false')
        pauseToggle.textContent = '⏸'
        Sound.resume()
        if (pendingFn) {
          timer = setTimeout(pendingFn, pendingDelay)
          pendingStart = Date.now()
        }
        if (!bpmInterval) bpmInterval = setInterval(tickBpm, 550)
      }

      function applyMotif (text) {
        if (SHOW_SHADOW.has(text)) {
          doorShadow.classList.add('show')
          doorShadow.classList.remove('face')
        }
        if (FACE_SHADOW.has(text)) {
          doorShadow.classList.add('show')
          doorShadow.classList.add('face')
        }
        if (HIDE_SHADOW.has(text)) {
          doorShadow.classList.remove('show')
          doorShadow.classList.remove('face')
        }
      }

      function jolt (white) {
        stage.classList.remove('shake')
        void stage.offsetWidth
        stage.classList.add('shake')
        flashEl.classList.remove('go', 'go-white')
        void flashEl.offsetWidth
        flashEl.classList.add(white ? 'go-white' : 'go')
        Sound.jolt()
        clearTimeout(joltCleanupTimer)
        joltCleanupTimer = setTimeout(function () { stage.classList.remove('shake') }, 420)
        bpmSpikeUntil = Date.now() + 2200
      }

      function targetBpm () {
        var base = 58 + tensionValue * 55
        if (calming) base = 54
        if (panicking) base = Math.max(base, 130)
        if (Date.now() < bpmSpikeUntil) base += 26
        base += Math.random() * 6 - 3
        return Math.min(182, Math.max(46, base))
      }

      function tickBpm () {
        var target = targetBpm()
        displayBpm += (target - displayBpm) * 0.45
        bpmValueEl.textContent = Math.round(displayBpm)
      }

      function startBpm () {
        if (bpmInterval) return
        bpmMeter.classList.add('show')
        tickBpm()
        bpmInterval = setInterval(tickBpm, 550)
      }

      function stopBpm () {
        if (bpmInterval) { clearInterval(bpmInterval); bpmInterval = null }
        bpmMeter.classList.remove('show')
      }

      function startPanic () {
        if (panicking) return
        panicking = true
        document.body.classList.add('panic')
        stage.classList.add('panic-jitter')
        Sound.startPanic()
        setTension(BEATS.length > 1 ? Math.min(1, Math.max(0, i) / (BEATS.length - 1)) : 0)
      }

      function stopPanic () {
        if (!panicking) return
        panicking = false
        document.body.classList.remove('panic')
        stage.classList.remove('panic-jitter')
        Sound.stopPanic()
        setTension(BEATS.length > 1 ? Math.min(1, Math.max(0, i) / (BEATS.length - 1)) : 0)
      }

      function startCalm () {
        if (calming) return
        calming = true
        document.body.classList.add('calm')
        Sound.muteDrone()
        setTension(BEATS.length > 1 ? Math.min(1, Math.max(0, i) / (BEATS.length - 1)) : 0)
      }

      function stopCalm (intense) {
        if (!calming) return
        calming = false
        document.body.classList.remove('calm')
        Sound.unmuteDrone(intense ? 0.34 : 0.16)
        setTension(BEATS.length > 1 ? Math.min(1, Math.max(0, i) / (BEATS.length - 1)) : 0)
      }

      function bigShock () {
        stopCalm(true)
        jolt(true)
        startPanic()
      }

      function showReveal (text) {
        revealCaption.textContent = text
        revealOverlay.classList.remove('hidden')
        void revealOverlay.offsetWidth
        revealOverlay.classList.add('show')
        jolt(false)
        Sound.startDread()
      }

      function hideReveal () {
        revealOverlay.classList.remove('show')
        revealOverlay.classList.add('hidden')
        Sound.stopDread()
      }

      function showComputerUI () {
        computerUI.classList.remove('hidden')
        void computerUI.offsetWidth
        computerUI.classList.add('show')
      }

      function hideComputerUI () {
        computerUI.classList.remove('show')
        computerUI.classList.add('hidden')
      }

      function showPhoneNotif (text) {
        if (phoneTimer) { clearTimeout(phoneTimer); phoneTimer = null }
        phoneNotifBody.textContent = text
        phoneNotif.classList.remove('hidden', 'open', 'nudge')
        void phoneNotif.offsetWidth
        phoneNotif.classList.add('show', 'shake-in')
        hintEl.textContent = 'toucher la notification'
        hintEl.classList.add('show')
        Sound.buzz()
        phoneTimer = setTimeout(function () {
          phoneNotif.classList.remove('shake-in')
          phoneTimer = null
        }, 700)
      }

      function nudgePhoneNotif () {
        phoneNotif.classList.remove('nudge')
        void phoneNotif.offsetWidth
        phoneNotif.classList.add('nudge')
        Sound.buzz()
      }

      function openPhoneNotif () {
        if (!awaitingPhone) return
        awaitingPhone = false
        if (phoneTimer) { clearTimeout(phoneTimer); phoneTimer = null }
        phoneNotif.classList.remove('shake-in', 'nudge')
        phoneNotif.classList.add('open')
        hintEl.textContent = 'cliquer pour continuer'
        phoneTimer = setTimeout(function () {
          phoneNotif.classList.remove('show', 'open')
          phoneNotif.classList.add('hidden')
          phoneTimer = null
          dismissThenAdvance(true)
        }, 320)
      }

      function scheduleNextUnless (b, hold) {
        if (!b.stop) scheduleNext(hold)
      }

      function renderBeat (b) {
        var text = b.x
        beatEl.className = ''
        beatEl.style.opacity = 0
        document.body.classList.remove('mode-computer')
        applyMotif(text)
        if (b.panic === 'start') startPanic()
        else if (b.panic === 'end') stopPanic()
        if (b.calm === 'start') startCalm()
        if (b.shock) bigShock()

        var duration // ms until auto-advance fires after fully shown

        if (b.t === 'knock') {
          beatEl.textContent = text
          beatEl.className = 'type-knock punch-in'
          jolt(false)
          duration = 620
          phase = 'holding'
          scheduleNextUnless(b, duration)
          return
        }

        if (b.t === 'phone') {
          showPhoneNotif(text)
          phase = 'holding'
          awaitingPhone = true
          return
        }

        if (b.t === 'reveal') {
          showReveal(text)
          phase = 'holding'
          scheduleNextUnless(b, 6500)
          return
        }

        if (b.t === 'screen') {
          document.body.classList.add('mode-computer')
          showComputerUI()
          typeWriter(cuText, text, function () {
            phase = 'holding'
            var hold = 1200 + wordCount(text) * 160
            if (JOLT.has(text)) jolt(text === 'MAINTENANT, TU PEUX REGARDER.')
            scheduleNextUnless(b, hold)
          })
          return
        }

        if (b.t === 'countdown') {
          beatEl.textContent = text
          beatEl.className = 'type-countdown punch-in'
          duration = 560
          phase = 'holding'
          scheduleNextUnless(b, duration)
          return
        }

        if (b.t === 'computer') {
          document.body.classList.add('mode-computer')
          beatEl.className = 'type-computer'
          beatEl.style.opacity = ''
          typeWriter(beatEl, text, function () {
            phase = 'holding'
            var hold = 750 + wordCount(text) * 140
            if (JOLT.has(text)) jolt(text === 'MAINTENANT, TU PEUX REGARDER.')
            scheduleNextUnless(b, hold)
          })
          return
        }

        var typeClass = b.t === 'whisper' ? 'type-whisper' : (b.t === 'title' ? 'type-title' : 'type-narration')
        var shortCue = (b.t === 'narration' && wordCount(text) <= 2) ? ' small' : ''
        beatEl.className = typeClass + shortCue + ' reveal'
        beatEl.textContent = text
        if (b.t === 'whisper') Sound.hiss()
        if (JOLT.has(text)) jolt(false)

        phase = 'revealing'
        var words = wordCount(text)
        var revealTime = b.t === 'whisper' ? 1400 : (b.t === 'title' ? 2600 : 700)
        var base = b.t === 'whisper' ? 900 : 650
        var perWord = b.t === 'whisper' ? 260 : 190
        var hold = Math.min(4200, Math.max(900, base + perWord * words))
        if (b.t === 'title') hold = 1800
        if (LONG_HOLD.has(text)) hold += 900

        setStoryTimeout(function () {
          phase = 'holding'
          scheduleNextUnless(b, hold)
        }, revealTime)
      }

      var typeTarget = null

      function typeWriter (el, text, done) {
        typing = true
        typeTarget = el
        el.textContent = ''
        var cursor = document.createElement('span')
        cursor.className = 'cursor'
        cursor.textContent = ' '
        var idx = 0
        var perChar = Math.max(18, Math.min(48, 900 / Math.max(text.length, 1)))

        function step () {
          if (idx <= text.length) {
            el.textContent = text.slice(0, idx)
            el.appendChild(cursor)
            idx++
            setStoryTimeout(step, perChar)
          } else {
            typing = false
            timer = null
            done()
          }
        }
        step()
      }

      function finishTyping () {
        clearTimer()
        typing = false
        var b = BEATS[i]
        if (typeTarget) typeTarget.textContent = b.x
        phase = 'holding'
        var hold = 500
        scheduleNextUnless(b, hold)
      }

      function scheduleNext (delay) {
        setStoryTimeout(advance, delay)
      }

      function dismissThenAdvance (hard) {
        clearTimer()
        var b = BEATS[i]
        if (b.t === 'reveal') {
          hideReveal()
          phase = 'dismissing'
          setStoryTimeout(next, reducedMotion ? 10 : 550)
          return
        }
        if (b.t === 'screen') {
          hideComputerUI()
          document.body.classList.remove('mode-computer')
          phase = 'dismissing'
          setStoryTimeout(next, reducedMotion ? 10 : 350)
          return
        }
        if (hard || b.t === 'knock' || b.t === 'countdown') {
          beatEl.className += ' punch-out'
          phase = 'dismissing'
          setStoryTimeout(next, reducedMotion ? 10 : 200)
        } else {
          beatEl.className += ' dismiss'
          phase = 'dismissing'
          setStoryTimeout(next, reducedMotion ? 10 : 500)
        }
      }

      function advance () {
        dismissThenAdvance(false)
      }

      function next () {
        i++
        setTension(Math.min(1, i / (BEATS.length - 1)))
        var pct = Math.min(100, (i / (BEATS.length - 1)) * 100)
        progressEl.style.width = pct + '%'
        updateSeekVisual(i)

        if (i >= BEATS.length) {
          finish()
          return
        }
        renderBeat(BEATS[i])
      }

      function updateSeekVisual (idx) {
        var pct = BEATS.length > 1 ? Math.max(0, Math.min(100, (idx / (BEATS.length - 1)) * 100)) : 0
        seekFill.style.width = pct + '%'
        seekHandle.style.left = pct + '%'
        seekBar.setAttribute('aria-valuenow', Math.round(pct))
      }

      function fastForwardTo (target) {
        if (!started || phase === 'done' || paused) return
        clearTimer()
        if (phoneTimer) { clearTimeout(phoneTimer); phoneTimer = null }
        awaitingPhone = false
        typing = false
        phoneNotif.classList.remove('show', 'shake-in', 'nudge', 'open')
        phoneNotif.classList.add('hidden')
        hideReveal()
        hideComputerUI()
        doorShadow.classList.remove('show', 'face')
        document.body.classList.remove('mode-computer')

        target = Math.max(0, Math.min(BEATS.length - 1, target))
        var panicActive = false
        var calmActive = false
        for (var k = 0; k <= target; k++) {
          applyMotif(BEATS[k].x)
          if (BEATS[k].panic === 'start') panicActive = true
          else if (BEATS[k].panic === 'end') panicActive = false
          if (BEATS[k].calm === 'start') calmActive = true
          if (BEATS[k].shock) { panicActive = true; calmActive = false }
        }
        if (calmActive) startCalm(); else stopCalm(false)
        if (panicActive) startPanic(); else stopPanic()
        i = target
        setTension(Math.min(1, i / (BEATS.length - 1)))
        progressEl.style.width = Math.min(100, (i / (BEATS.length - 1)) * 100) + '%'
        updateSeekVisual(i)
        renderBeat(BEATS[i])
      }

      function finish () {
        phase = 'done'
        doorShadow.classList.remove('show', 'face')
        document.body.classList.remove('mode-computer')
        stopPanic()
        stopCalm(false)
        stopBpm()
        Sound.muteDrone()
        hintEl.classList.remove('show')
        skipToggle.classList.remove('show')
        pauseToggle.classList.remove('show')
        seekBar.classList.remove('show')
        skipToggle.setAttribute('aria-pressed', 'false')
        startEnigma()
      }

      function startEnigma () {
        enigmaIndex = 0
        enigmaScore = 0
        enigmaFeedback.textContent = ''
        enigmaQuestions.forEach(function (q, idx) {
          q.classList.toggle('hide', idx !== 0)
          q.querySelectorAll('.opt').forEach(function (o) {
            o.disabled = false
            o.classList.remove('correct', 'wrong')
          })
        })
        enigmaPanel.classList.remove('hide')
      }

      var ENIGMA_FEEDBACK = [
        { right: 'L\'écriture au dos de la photo ne mentait pas.', wrong: 'Ce n\'est pas ce que disait l\'écriture au dos de la photo.' },
        { right: 'Le compteur, lui, ne mentait pas.', wrong: 'Relis le compteur. Il ne mentait pas.' }
      ]

      function handleEnigmaAnswer (btn) {
        var correct = btn.getAttribute('data-correct') === 'true'
        if (correct) enigmaScore++
        var opts = btn.parentElement.querySelectorAll('.opt')
        opts.forEach(function (o) {
          o.disabled = true
          if (o.getAttribute('data-correct') === 'true') o.classList.add('correct')
        })
        if (!correct) btn.classList.add('wrong')
        var fb = ENIGMA_FEEDBACK[enigmaIndex]
        enigmaFeedback.textContent = correct ? fb.right : fb.wrong
        enigmaTimer = setTimeout(nextEnigmaQuestion, 1300)
      }

      function nextEnigmaQuestion () {
        enigmaQuestions[enigmaIndex].classList.add('hide')
        enigmaIndex++
        enigmaFeedback.textContent = ''
        if (enigmaIndex >= enigmaQuestions.length) {
          enigmaPanel.classList.add('hide')
          showEnding()
          return
        }
        enigmaQuestions[enigmaIndex].classList.remove('hide')
      }

      function showEnding () {
        var full = enigmaScore >= enigmaQuestions.length
        if (full) {
          endVerdict.textContent = 'Tu as compris.'
          endDetail.textContent = 'Léa ne reviendra plus frapper — pas cette nuit.'
        } else {
          endVerdict.textContent = 'Tu n\'as pas tout vu.'
          endDetail.textContent = 'Elle reviendra. Elle revient toujours.'
        }
        endPanel.classList.remove('hide')
      }

      function skip () {
        if (phase === 'revealing') {
          clearTimer()
          var b = BEATS[i]
          beatEl.style.opacity = 1
          beatEl.style.transform = 'none'
          phase = 'holding'
          var hold = b.t === 'whisper' ? 500 : 350
          scheduleNextUnless(b, hold)
        } else if (typing) {
          finishTyping()
        } else if (phase === 'holding') {
          clearTimer()
          dismissThenAdvance(false)
        }
      }

      function begin () {
        if (started) return
        started = true
        startPanel.classList.add('hide')
        hintEl.classList.add('show')
        skipToggle.classList.add('show')
        pauseToggle.classList.add('show')
        displayBpm = 66
        startBpm()
        Sound.turnOn()
        soundBtn.setAttribute('aria-pressed', 'true')
        soundBtn.textContent = '♪'
        soundBtn.style.opacity = '1'
        next()
      }

      function restart () {
        clearTimer()
        if (phoneTimer) { clearTimeout(phoneTimer); phoneTimer = null }
        if (enigmaTimer) { clearTimeout(enigmaTimer); enigmaTimer = null }
        i = -1
        setTension(0)
        progressEl.style.width = '0%'
        updateSeekVisual(0)
        beatEl.textContent = ''
        beatEl.className = ''
        endPanel.classList.add('hide')
        enigmaPanel.classList.add('hide')
        endVerdict.textContent = ''
        endDetail.textContent = ''
        doorShadow.classList.remove('show', 'face')
        started = false
        awaitingPhone = false
        phoneNotif.classList.remove('show', 'shake-in', 'nudge', 'open')
        phoneNotif.classList.add('hidden')
        hideReveal()
        hideComputerUI()
        stopPanic()
        stopCalm(false)
        stopBpm()
        Sound.unmuteDrone(0.16)
        if (paused) {
          paused = false
          document.body.classList.remove('paused')
          pauseToggle.setAttribute('aria-pressed', 'false')
          pauseToggle.textContent = '⏸'
        }
        Sound.resume()
        pendingFn = null
        hintEl.textContent = 'cliquer pour continuer'
        startPanel.classList.remove('hide')
        hintEl.classList.remove('show')
        skipToggle.classList.remove('show')
        skipToggle.setAttribute('aria-pressed', 'false')
        pauseToggle.classList.remove('show')
        seekBar.classList.remove('show')
      }

      function requestFullscreen () {
        var el = document.documentElement
        var req = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen
        if (!req) return
        try {
          var res = req.call(el)
          if (res && res.catch) res.catch(function () {})
        } catch (err) {}
      }

      fullscreenBtn.addEventListener('click', function (e) {
        e.stopPropagation()
        fsConfirm.classList.remove('hidden')
        requestAnimationFrame(function () { fsConfirm.classList.add('show') })
        fsConfirmYes.focus()
      })

      function closeFsConfirm () {
        fsConfirm.classList.remove('show')
        setTimeout(function () {
          fsConfirm.classList.add('hidden')
          fsConfirm.classList.remove('loading')
          fsConfirmYes.disabled = false
          fsConfirmNo.disabled = false
        }, 250)
      }

      fsConfirmYes.addEventListener('click', function (e) {
        e.stopPropagation()
        fsConfirmYes.disabled = true
        fsConfirmNo.disabled = true
        fsConfirm.classList.add('loading')
        setTimeout(function () {
          closeFsConfirm()
          requestFullscreen()
          begin()
        }, 1900)
      })
      fsConfirmNo.addEventListener('click', function (e) {
        e.stopPropagation()
        closeFsConfirm()
      })
      fsConfirm.addEventListener('click', function (e) {
        if (e.target === fsConfirm && !fsConfirm.classList.contains('loading')) closeFsConfirm()
      })
      plainBtn.addEventListener('click', function (e) {
        e.stopPropagation()
        begin()
      })

      document.addEventListener('click', function (e) {
        if (e.target === soundBtn || e.target === replayBtn) return
        if (!started) return
        if (phase === 'done') return
        if (paused) return
        if (awaitingPhone) { nudgePhoneNotif(); return }
        skip()
      })
      document.addEventListener('keydown', function (e) {
        if (e.code === 'KeyP') {
          if (!started || phase === 'done') return
          e.preventDefault()
          if (paused) resumeGame(); else pauseGame()
          return
        }
        if (e.code !== 'Space' && e.code !== 'Enter') return
        if (!started) return
        if (paused) return
        if (awaitingPhone) return
        e.preventDefault()
        if (phase === 'done') return
        skip()
      })
      replayBtn.addEventListener('click', function (e) {
        e.stopPropagation()
        restart()
      })

      phoneNotif.addEventListener('click', function (e) {
        e.stopPropagation()
        openPhoneNotif()
      })
      phoneNotif.addEventListener('keydown', function (e) {
        if (e.code !== 'Space' && e.code !== 'Enter') return
        e.preventDefault()
        e.stopPropagation()
        openPhoneNotif()
      })

      skipToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        if (!started || phase === 'done') return
        var showing = seekBar.classList.toggle('show')
        skipToggle.setAttribute('aria-pressed', showing ? 'true' : 'false')
        if (showing) updateSeekVisual(i < 0 ? 0 : i)
      })

      pauseToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        if (paused) resumeGame(); else pauseGame()
      })

      function seekFromEvent (e) {
        var rect = seekBar.getBoundingClientRect()
        var pct = (e.clientX - rect.left) / rect.width
        pct = Math.max(0, Math.min(1, pct))
        fastForwardTo(Math.round(pct * (BEATS.length - 1)))
      }

      seekBar.addEventListener('click', function (e) { e.stopPropagation() })
      seekBar.addEventListener('pointerdown', function (e) {
        e.stopPropagation()
        if (!started || phase === 'done' || paused) return
        seekDragging = true
        if (seekBar.setPointerCapture) seekBar.setPointerCapture(e.pointerId)
        seekFromEvent(e)
      })
      seekBar.addEventListener('pointermove', function (e) {
        if (!seekDragging) return
        seekFromEvent(e)
      })
      seekBar.addEventListener('pointerup', function () {
        seekDragging = false
      })
      seekBar.addEventListener('keydown', function (e) {
        if (!started || phase === 'done') return
        var cur = i < 0 ? 0 : i
        if (e.code === 'ArrowRight') { e.preventDefault(); fastForwardTo(cur + 1) } else if (e.code === 'ArrowLeft') { e.preventDefault(); fastForwardTo(cur - 1) }
      })

      enigmaPanel.addEventListener('click', function (e) {
        e.stopPropagation()
        var btn = e.target.closest ? e.target.closest('.opt') : null
        if (!btn || btn.disabled) return
        handleEnigmaAnswer(btn)
      })

      /* ---------- grain canvas ---------- */

      var grainCanvas = document.createElement('canvas')
      document.getElementById('grain').appendChild(grainCanvas)
      var gctx = grainCanvas.getContext('2d')
      var GW = 140; var GH = 90
      grainCanvas.width = GW; grainCanvas.height = GH
      grainCanvas.style.width = '100%'
      grainCanvas.style.height = '100%'

      function drawGrain () {
        var imgData = gctx.createImageData(GW, GH)
        var d = imgData.data
        for (var p = 0; p < d.length; p += 4) {
          var v = (Math.random() * 255) | 0
          d[p] = v; d[p + 1] = v; d[p + 2] = v; d[p + 3] = 255
        }
        gctx.putImageData(imgData, 0, 0)
      }
      drawGrain()
      if (!reducedMotion) {
        setInterval(drawGrain, 120)
      }

      /* ---------- synthesized audio ---------- */

      var Sound = {
        ctx: null,
        master: null,
        on: false,
        noiseBuf: null,
        heartTimer: null,
        dreadNodes: null,
        panicPulseTimer: null,
        panicWasRunning: false,
        droneGain: null,

        ensure: function () {
          if (this.ctx) return
          var AC = window.AudioContext || window.webkitAudioContext
          if (!AC) return
          this.ctx = new AC()
          this.master = this.ctx.createGain()
          this.master.gain.value = 0
          this.master.connect(this.ctx.destination)
          this.buildNoise()
          this.startDrone()
        },

        buildNoise: function () {
          var len = this.ctx.sampleRate * 2
          var buf = this.ctx.createBuffer(1, len, this.ctx.sampleRate)
          var d = buf.getChannelData(0)
          for (var n = 0; n < len; n++) d[n] = Math.random() * 2 - 1
          this.noiseBuf = buf
        },

        startDrone: function () {
          var ctx = this.ctx
          var o1 = ctx.createOscillator(); o1.type = 'sine'; o1.frequency.value = 47
          var o2 = ctx.createOscillator(); o2.type = 'sine'; o2.frequency.value = 49.7
          var g = ctx.createGain(); g.gain.value = 0.16
          var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 200
          o1.connect(g); o2.connect(g); g.connect(lp); lp.connect(this.master)
          o1.start(); o2.start()
          this.droneGain = g
        },

        muteDrone: function () {
          if (!this.ctx || !this.droneGain) return
          var t = this.ctx.currentTime
          this.droneGain.gain.cancelScheduledValues(t)
          this.droneGain.gain.setValueAtTime(this.droneGain.gain.value, t)
          this.droneGain.gain.linearRampToValueAtTime(0.0001, t + 1.2)
        },

        unmuteDrone: function (target) {
          if (!this.ctx || !this.droneGain) return
          var t = this.ctx.currentTime
          this.droneGain.gain.cancelScheduledValues(t)
          this.droneGain.gain.setValueAtTime(this.droneGain.gain.value, t)
          this.droneGain.gain.linearRampToValueAtTime(target || 0.16, t + 0.4)
        },

        toggle: function () {
          this.ensure()
          if (!this.ctx) return false
          if (this.ctx.state === 'suspended') this.ctx.resume()
          this.on = !this.on
          var t = this.ctx.currentTime
          this.master.gain.cancelScheduledValues(t)
          this.master.gain.linearRampToValueAtTime(this.on ? 0.55 : 0, t + 0.5)
          return this.on
        },

        turnOn: function () {
          this.ensure()
          if (!this.ctx || this.on) return
          if (this.ctx.state === 'suspended') this.ctx.resume()
          this.on = true
          var t = this.ctx.currentTime
          this.master.gain.cancelScheduledValues(t)
          this.master.gain.linearRampToValueAtTime(0.55, t + 0.5)
        },

        pause: function () {
          if (this.ctx && this.ctx.state === 'running') this.ctx.suspend()
          if (this.panicPulseTimer) {
            clearInterval(this.panicPulseTimer)
            this.panicPulseTimer = null
            this.panicWasRunning = true
          }
        },

        resume: function () {
          if (this.ctx && this.ctx.state === 'suspended') this.ctx.resume()
          if (this.panicWasRunning) {
            var self = this
            this.panicPulseTimer = setInterval(function () { self.heartThump() }, 430)
            this.panicWasRunning = false
          }
        },

        knock: function () {
          if (!this.ctx) return
          var t = this.ctx.currentTime
          var o = this.ctx.createOscillator(); o.type = 'sine'
          o.frequency.setValueAtTime(95, t)
          o.frequency.exponentialRampToValueAtTime(38, t + 0.2)
          var g = this.ctx.createGain()
          g.gain.setValueAtTime(0.001, t)
          g.gain.exponentialRampToValueAtTime(0.9, t + 0.01)
          g.gain.exponentialRampToValueAtTime(0.001, t + 0.26)
          o.connect(g); g.connect(this.master)
          o.start(t); o.stop(t + 0.3)
        },

        buzz: function () {
          if (!this.ctx) return
          var ctx = this.ctx
          var t = ctx.currentTime
          for (var k = 0; k < 4; k++) {
            var start = t + k * 0.1
            var o = ctx.createOscillator(); o.type = 'square'; o.frequency.value = 130
            var g = ctx.createGain()
            g.gain.setValueAtTime(0.0001, start)
            g.gain.linearRampToValueAtTime(0.06, start + 0.01)
            g.gain.exponentialRampToValueAtTime(0.0001, start + 0.08)
            o.connect(g); g.connect(this.master)
            o.start(start); o.stop(start + 0.09)
          }
        },

        hiss: function () {
          if (!this.ctx || !this.noiseBuf) return
          var t = this.ctx.currentTime
          var src = this.ctx.createBufferSource(); src.buffer = this.noiseBuf
          var bp = this.ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 1800; bp.Q.value = 0.6
          var g = this.ctx.createGain()
          g.gain.setValueAtTime(0.0001, t)
          g.gain.linearRampToValueAtTime(0.12, t + 0.15)
          g.gain.exponentialRampToValueAtTime(0.0001, t + 0.9)
          src.connect(bp); bp.connect(g); g.connect(this.master)
          src.start(t); src.stop(t + 1)
        },

        jolt: function () {
          if (!this.ctx || !this.noiseBuf) return
          var t = this.ctx.currentTime
          var src = this.ctx.createBufferSource(); src.buffer = this.noiseBuf
          var g = this.ctx.createGain()
          g.gain.setValueAtTime(0.5, t)
          g.gain.exponentialRampToValueAtTime(0.001, t + 0.35)
          src.connect(g); g.connect(this.master)
          src.start(t); src.stop(t + 0.4)
          this.knock()
        },

        startDread: function () {
          if (!this.ctx) return
          this.stopDread()
          var ctx = this.ctx
          var t = ctx.currentTime

          var g = ctx.createGain()
          g.gain.setValueAtTime(0.0001, t)
          g.gain.linearRampToValueAtTime(0.24, t + 0.4)
          g.connect(this.master)

          var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 260
          var sub1 = ctx.createOscillator(); sub1.type = 'sawtooth'; sub1.frequency.value = 54
          var sub2 = ctx.createOscillator(); sub2.type = 'sawtooth'; sub2.frequency.value = 57.5
          sub1.connect(lp); sub2.connect(lp); lp.connect(g)

          var hiGain = ctx.createGain(); hiGain.gain.value = 0.4
          var hi1 = ctx.createOscillator(); hi1.type = 'sine'; hi1.frequency.value = 233
          var hi2 = ctx.createOscillator(); hi2.type = 'sine'; hi2.frequency.value = 247
          hi1.connect(hiGain); hi2.connect(hiGain); hiGain.connect(g)

          var lfo = ctx.createOscillator(); lfo.type = 'sine'; lfo.frequency.value = 5.3
          var lfoGain = ctx.createGain(); lfoGain.gain.value = 7
          lfo.connect(lfoGain); lfoGain.connect(hi1.frequency)

          var noise = ctx.createBufferSource(); noise.buffer = this.noiseBuf; noise.loop = true
          var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 90; bp.Q.value = 0.9
          var noiseGain = ctx.createGain(); noiseGain.gain.value = 0.5
          noise.connect(bp); bp.connect(noiseGain); noiseGain.connect(g)

          var osc = [sub1, sub2, hi1, hi2, lfo]
          osc.forEach(function (o) { o.start(t) })
          noise.start(t)

          this.dreadNodes = { gain: g, osc: osc, noise: noise }
        },

        stopDread: function () {
          if (!this.ctx || !this.dreadNodes) return
          var t = this.ctx.currentTime
          var nodes = this.dreadNodes
          nodes.gain.gain.cancelScheduledValues(t)
          nodes.gain.gain.setValueAtTime(nodes.gain.gain.value, t)
          nodes.gain.gain.linearRampToValueAtTime(0.0001, t + 0.5)
          var stopAt = t + 0.55
          nodes.osc.forEach(function (o) { o.stop(stopAt) })
          nodes.noise.stop(stopAt)
          this.dreadNodes = null
        },

        heartThump: function () {
          if (!this.ctx) return
          var t = this.ctx.currentTime
          var o = this.ctx.createOscillator(); o.type = 'sine'
          o.frequency.setValueAtTime(72, t)
          o.frequency.exponentialRampToValueAtTime(34, t + 0.14)
          var g = this.ctx.createGain()
          g.gain.setValueAtTime(0.0001, t)
          g.gain.linearRampToValueAtTime(0.42, t + 0.02)
          g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22)
          o.connect(g); g.connect(this.master)
          o.start(t); o.stop(t + 0.25)
        },

        ringOnce: function () {
          if (!this.ctx) return
          var t = this.ctx.currentTime
          var dur = 2.8
          var g = this.ctx.createGain()
          g.gain.setValueAtTime(0.0001, t)
          g.gain.linearRampToValueAtTime(0.045, t + 0.55)
          g.gain.setValueAtTime(0.045, t + dur * 0.45)
          g.gain.exponentialRampToValueAtTime(0.0001, t + dur)
          g.connect(this.master)

          var o = this.ctx.createOscillator(); o.type = 'sine'; o.frequency.value = 3100
          var lfo = this.ctx.createOscillator(); lfo.type = 'sine'; lfo.frequency.value = 0.45
          var lfoGain = this.ctx.createGain(); lfoGain.gain.value = 9
          lfo.connect(lfoGain); lfoGain.connect(o.detune)
          o.connect(g)
          var stopAt = t + dur + 0.2
          o.start(t); lfo.start(t)
          o.stop(stopAt); lfo.stop(stopAt)
        },

        startPanic: function () {
          if (!this.ctx) return
          this.stopPanic()
          var self = this
          this.heartThump()
          this.ringOnce()
          this.panicPulseTimer = setInterval(function () { self.heartThump() }, 430)
        },

        stopPanic: function () {
          if (this.panicPulseTimer) { clearInterval(this.panicPulseTimer); this.panicPulseTimer = null }
        }
      }

      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation()
        var on = Sound.toggle()
        soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false')
        soundBtn.textContent = on ? '♪' : '♪̸'
        soundBtn.style.opacity = on ? '1' : ''
      })

      setTension(0)
    })()
  }
}
</script>

<style>
:root{
  --void:#050404;
  --void-2:#0a0807;
  --ash:#16110f;
  --bone:#e8e1d2;
  --bone-dim:#8c8377;
  --bone-faint:#524c44;
  --ember:#7c1c17;
  --ember-bright:#c8392c;
  --phosphor:#c3d3ba;
  --phosphor-dim:#5e6b58;
  --whisper:#a68fb2;
  --whisper-dim:#463c4d;
  --tension:0;
  --heartbeat-dur:1.2s;
}

*{ box-sizing:border-box; }

html,body{
  margin:0;
  padding:0;
  height:100%;
  background:var(--void);
  overscroll-behavior:none;
}

body{
  min-height:100dvh;
  color:var(--bone);
  font-family:"Cormorant Garamond", "Iowan Old Style", Georgia, serif;
  overflow:hidden;
  -webkit-font-smoothing:antialiased;
  cursor:default;
  user-select:none;
}

/* ---------- ambient layers ---------- */

#grain{
  position:fixed; inset:0;
  z-index:2;
  pointer-events:none;
  opacity:.05;
  mix-blend-mode:overlay;
  transition:opacity 1.2s ease;
}

#vignette{
  position:fixed; inset:0;
  z-index:3;
  pointer-events:none;
  background:
    radial-gradient(ellipse 70% 60% at 50% 48%, transparent 0%, rgba(5,4,4, calc(.32 + var(--tension) * .38)) 62%, rgba(5,4,4, calc(.78 + var(--tension) * .2)) 100%),
    radial-gradient(ellipse 90% 90% at 50% 105%, rgba(124,28,23, calc(var(--tension) * .16)) 0%, transparent 55%);
  animation: heartbeat var(--heartbeat-dur) ease-in-out infinite;
  transition:opacity 1.2s ease;
}

#calm-wash{
  position:fixed; inset:0;
  z-index:3;
  pointer-events:none;
  opacity:0;
  background:radial-gradient(ellipse 90% 80% at 50% 38%, rgba(232,225,210,.12) 0%, transparent 66%);
  transition:opacity 1.6s ease;
}
body.calm #calm-wash{ opacity:1; }
body.calm #vignette{ opacity:.5; }
body.calm #grain{ opacity:.02; }

@keyframes heartbeat{
  0%, 100%{ filter:brightness(1); }
  50%{ filter:brightness(1.035); }
}

#panic-tint{
  position:fixed; inset:0;
  z-index:3;
  pointer-events:none;
  opacity:0;
  background:radial-gradient(ellipse 95% 90% at 50% 55%, rgba(124,28,23,.3) 0%, transparent 62%);
  transition:opacity .7s ease;
}
body.panic #panic-tint{
  opacity:1;
  animation: heartbeat var(--heartbeat-dur) ease-in-out infinite;
}
body.panic #grain{ opacity:.11; }

#stage.panic-jitter{
  animation: panic-jitter .13s steps(2) infinite;
}
#stage.panic-jitter.shake{
  animation: shake .4s cubic-bezier(.36,.07,.19,.97);
}
@keyframes panic-jitter{
  0%,100%{ transform:translate(0,0); }
  25%{ transform:translate(-2px,1px); }
  50%{ transform:translate(2px,-1px); }
  75%{ transform:translate(-1px,-2px); }
}

#scanlines{
  position:fixed; inset:0;
  z-index:4;
  pointer-events:none;
  opacity:0;
  transition:opacity .5s ease;
  background:repeating-linear-gradient(
    to bottom,
    rgba(195,211,186,.05) 0px,
    rgba(195,211,186,.05) 1px,
    transparent 2px,
    transparent 3px
  );
}
body.mode-computer #scanlines{ opacity:.55; }

#flash{
  position:fixed; inset:0;
  z-index:9;
  pointer-events:none;
  opacity:0;
  background:var(--ember-bright);
}
#flash.go{ animation:jolt .5s ease-out; }
#flash.go-white{ animation:jolt-white .42s ease-out; }
@keyframes jolt{
  0%{ opacity:0; }
  6%{ opacity:.72; }
  100%{ opacity:0; }
}
@keyframes jolt-white{
  0%{ opacity:0; background:var(--bone); }
  5%{ opacity:.9; background:var(--bone); }
  100%{ opacity:0; background:var(--bone); }
}

#progress{
  position:fixed; left:0; bottom:0;
  z-index:6;
  height:2px;
  width:0%;
  background:linear-gradient(to right, var(--ember), var(--ember-bright));
  opacity:.3;
  transition:width .35s linear;
}

/* ---------- stage ---------- */

#stage{
  position:relative;
  z-index:5;
  height:100dvh;
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  padding:8vh 6vw;
}
#stage.shake{ animation:shake .4s cubic-bezier(.36,.07,.19,.97); }
@keyframes shake{
  10%,90%{ transform:translate3d(-1px,0,0); }
  20%,80%{ transform:translate3d(2px,0,0); }
  30%,50%,70%{ transform:translate3d(-5px,0,0); }
  40%,60%{ transform:translate3d(5px,0,0); }
}

.panel{
  position:absolute;
  inset:0;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:8vh 6vw;
}

/* ---------- start screen ---------- */

#start{
  flex-direction:column;
  gap:2.2rem;
}
#start .eyebrow{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.7rem;
  letter-spacing:.32em;
  text-transform:uppercase;
  color:var(--bone-faint);
  animation:fade-in-up .8s ease-out both, eyebrow-flicker 6s ease-in-out infinite .8s;
}
@keyframes eyebrow-flicker{
  0%,89%,93%,100%{ opacity:1; }
  91%{ opacity:.15; }
}
#start h1{
  margin:0;
  font-weight:500;
  font-size:clamp(2.1rem, 7vw, 4.4rem);
  letter-spacing:.01em;
  line-height:1.08;
  text-wrap:balance;
  color:var(--bone);
  text-shadow:0 0 26px rgba(232,225,210,.16), 0 0 3px rgba(232,225,210,.35);
  animation:title-intro 3s cubic-bezier(.16,.7,.2,1) .3s both, title-breathe 7s ease-in-out infinite 3.3s;
}
@keyframes title-intro{
  0%{
    opacity:0;
    transform:scale(.55);
    letter-spacing:.4em;
    filter:blur(16px);
  }
  60%{
    opacity:1;
    filter:blur(0);
  }
  100%{
    opacity:.92;
    transform:scale(1);
    letter-spacing:.01em;
    filter:blur(0);
  }
}
@keyframes title-breathe{
  0%,100%{ opacity:.92; }
  50%{ opacity:1; text-shadow:0 0 40px rgba(200,57,44,.18), 0 0 3px rgba(232,225,210,.4); }
}
#start .enter{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.78rem;
  letter-spacing:.18em;
  text-transform:uppercase;
  color:var(--phosphor-dim);
  animation:pulse-soft 2.6s ease-in-out infinite;
  margin-top:1rem;
}
@keyframes pulse-soft{
  0%,100%{ opacity:.45; }
  50%{ opacity:1; }
}
#start .meta{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.64rem;
  letter-spacing:.16em;
  text-transform:uppercase;
  color:var(--bone-dim);
  margin-top:-.6rem;
  opacity:0;
  animation:meta-in .9s ease-out 2.6s both;
}
@keyframes meta-in{
  from{ opacity:0; transform:translateY(16px); }
  to{ opacity:.75; transform:translateY(0); }
}
#start .start-actions{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:1.3rem;
  margin-top:.6rem;
  opacity:0;
  animation:fade-in-up .9s ease-out 3s both;
}
#start .cta{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.76rem;
  letter-spacing:.22em;
  text-transform:uppercase;
  color:var(--bone);
  background:rgba(232,225,210,.03);
  border:1px solid rgba(232,225,210,.28);
  border-radius:2px;
  padding:1rem 1.9rem;
  cursor:pointer;
  display:flex;
  align-items:center;
  gap:.85rem;
  animation:cta-glow 3.2s ease-in-out infinite;
  transition:transform .25s ease, border-color .25s ease, background-color .25s ease;
}
#start .cta:hover, #start .cta:focus-visible{
  transform:translateY(-1px);
  border-color:rgba(232,225,210,.6);
  background:rgba(232,225,210,.07);
}
#start .cta-icon{
  font-size:1.05rem;
  line-height:1;
  color:var(--bone-dim);
  transform:scaleX(.85);
}
@keyframes cta-glow{
  0%,100%{ box-shadow:0 0 0 rgba(200,57,44,0); }
  50%{ box-shadow:0 0 20px rgba(200,57,44,.16); }
}
#start .cta .cta-tag{
  font-size:.56rem;
  letter-spacing:.1em;
  color:var(--ember-bright);
  border:1px solid rgba(200,57,44,.45);
  border-radius:2px;
  padding:.2rem .45rem;
  white-space:nowrap;
}
#start .enter-plain{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.66rem;
  letter-spacing:.12em;
  text-transform:uppercase;
  color:var(--bone-faint);
  background:none;
  border:none;
  border-bottom:1px solid transparent;
  cursor:pointer;
  opacity:.55;
  padding:.3rem 0;
  transition:opacity .2s ease, border-color .2s ease;
}
#start .enter-plain:hover, #start .enter-plain:focus-visible{
  opacity:.95;
  border-bottom-color:var(--bone-faint);
}
#start .warn{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.62rem;
  letter-spacing:.08em;
  color:var(--bone-faint);
  max-width:34ch;
  line-height:1.7;
  opacity:0;
  animation:warn-in .9s ease-out 3.3s both;
}
@keyframes warn-in{
  from{ opacity:0; transform:translateY(16px); }
  to{ opacity:.7; transform:translateY(0); }
}
#start .credits{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.6rem;
  letter-spacing:.14em;
  text-transform:uppercase;
  color:var(--bone-faint);
  margin-top:.4rem;
  opacity:0;
  animation:credits-in .9s ease-out 3.5s both;
}
@keyframes credits-in{
  from{ opacity:0; transform:translateY(16px); }
  to{ opacity:.4; transform:translateY(0); }
}
#start.hide, #end.hide, #enigma.hide{
  display:none;
}

/* ---------- fullscreen confirm ---------- */

#fs-confirm{
  position:fixed;
  inset:0;
  z-index:20;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:6vw;
  background:rgba(5,4,4,.86);
  backdrop-filter:blur(4px);
  opacity:0;
  pointer-events:none;
  transition:opacity .35s ease;
}
#fs-confirm.hidden{ display:none; }
#fs-confirm.show{
  opacity:1;
  pointer-events:auto;
}
.fs-confirm-box{
  position:relative;
  width:min(94vw, 30rem);
  text-align:center;
  border:1px solid rgba(232,225,210,.24);
  background:
    radial-gradient(ellipse 120% 100% at 50% -10%, rgba(200,57,44,.07), transparent 55%),
    rgba(10,8,7,.94);
  border-radius:3px;
  padding:3rem 2.8rem 2.6rem;
  transform:translateY(6px) scale(.98);
  transition:transform .35s cubic-bezier(.16,.7,.2,1);
  box-shadow:0 0 3px rgba(232,225,210,.08), 0 20px 60px rgba(0,0,0,.7);
}
.fs-confirm-box::before{
  content:"";
  position:absolute;
  top:0; left:50%;
  width:64px;
  height:1px;
  transform:translateX(-50%);
  background:linear-gradient(to right, transparent, var(--ember-bright), transparent);
  animation:cta-glow 3.2s ease-in-out infinite;
}
#fs-confirm.show .fs-confirm-box{
  transform:translateY(0) scale(1);
}
#fs-confirm-text{
  margin:0 0 2.2rem;
  font-family:"Cormorant Garamond", Georgia, serif;
  font-size:clamp(1.3rem, 2.8vw, 1.55rem);
  line-height:1.5;
  color:var(--bone);
  text-shadow:0 2px 14px rgba(0,0,0,.7);
}
#fs-confirm-text em{
  display:block;
  margin-top:.7rem;
  color:var(--ember-bright);
  font-style:italic;
  font-size:.94em;
  opacity:.92;
}
.fs-confirm-actions{
  display:flex;
  flex-direction:column;
  align-items:stretch;
  gap:.9rem;
}
.fs-confirm-btn{
  font-family:"Space Mono", ui-monospace, monospace;
  cursor:pointer;
  transition:transform .25s ease, border-color .25s ease, background-color .25s ease, opacity .2s ease;
}
.fs-confirm-yes{
  color:var(--bone);
  font-size:.8rem;
  letter-spacing:.2em;
  text-transform:uppercase;
  background:rgba(232,225,210,.04);
  border:1px solid rgba(232,225,210,.32);
  border-radius:2px;
  padding:1.05rem 1.7rem;
}
.fs-confirm-yes:hover, .fs-confirm-yes:focus-visible{
  transform:translateY(-1px);
  border-color:rgba(232,225,210,.65);
  background:rgba(232,225,210,.09);
}
.fs-confirm-no{
  color:var(--bone-faint);
  font-size:.68rem;
  letter-spacing:.14em;
  text-transform:uppercase;
  background:none;
  border:none;
  opacity:.5;
  padding:.4rem 0 0;
}
.fs-confirm-no:hover, .fs-confirm-no:focus-visible{
  opacity:.9;
}
.fs-confirm-loading{
  display:none;
  margin:0;
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.72rem;
  letter-spacing:.2em;
  text-transform:uppercase;
  color:var(--bone-faint);
  animation:eyebrow-flicker 2.4s ease-in-out infinite;
}
#fs-confirm.loading #fs-confirm-text,
#fs-confirm.loading .fs-confirm-actions{
  display:none;
}
#fs-confirm.loading .fs-confirm-loading{
  display:block;
}
.fs-dots span{
  animation:fs-dot-pulse 1.4s ease-in-out infinite;
  opacity:.2;
}
.fs-dots span:nth-child(2){ animation-delay:.2s; }
.fs-dots span:nth-child(3){ animation-delay:.4s; }
@keyframes fs-dot-pulse{
  0%,60%,100%{ opacity:.2; }
  30%{ opacity:1; }
}

/* ---------- beat text ---------- */

#beat{
  max-width:56ch;
  font-size:clamp(1.9rem, 4.6vw, 3.2rem);
  line-height:1.5;
  font-weight:400;
  color:var(--bone);
  opacity:0;
  text-wrap:balance;
}

#beat.type-title{
  font-size:clamp(2rem, 6vw, 3.6rem);
  font-weight:500;
  letter-spacing:.01em;
}

#beat.type-narration{
  font-weight:400;
}
#beat.small{ font-size:clamp(1.5rem, 3.4vw, 2.4rem); color:var(--bone-dim); }

#beat.type-whisper{
  font-style:italic;
  font-weight:400;
  color:var(--whisper);
  letter-spacing:.03em;
  text-shadow:0 0 18px rgba(166,143,178,.4);
}

#beat.type-computer{
  opacity:1;
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:clamp(1.15rem, 2.6vw, 1.9rem);
  letter-spacing:.02em;
  color:var(--phosphor);
  text-shadow:0 0 12px rgba(195,211,186,.55), 0 0 2px rgba(195,211,186,.8), 2px 0 rgba(200,57,44,.18), -2px 0 rgba(166,143,178,.14);
  max-width:44ch;
}
#beat.type-computer .cursor{
  display:inline-block;
  width:.5em;
  margin-left:.05em;
  background:var(--phosphor);
  animation:blink 1s steps(1) infinite;
}
@keyframes blink{ 50%{ opacity:0; } }

#beat.type-knock{
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:clamp(2.4rem, 8vw, 5rem);
  letter-spacing:.06em;
  color:var(--ember-bright);
  text-shadow:0 0 30px rgba(200,57,44,.5);
}

#beat.type-countdown{
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:clamp(2.2rem, 7vw, 4.2rem);
  letter-spacing:.08em;
  color:var(--ember-bright);
  text-shadow:0 0 24px rgba(200,57,44,.55);
  font-variant-numeric:tabular-nums;
}

#beat.reveal{ animation:fade-in-up .7s ease-out forwards; }
#beat.hold{ opacity:1; }
#beat.dismiss{ animation:fade-out-up .55s ease-in forwards; }
#beat.punch-in{ animation:punch-in .38s cubic-bezier(.2,1.4,.4,1) forwards; }
#beat.punch-out{ animation:punch-out .22s ease-in forwards; }

@keyframes fade-in-up{
  from{ opacity:0; transform:translateY(16px); }
  to{ opacity:1; transform:translateY(0); }
}
@keyframes fade-out-up{
  from{ opacity:1; transform:translateY(0); }
  to{ opacity:0; transform:translateY(-12px); }
}
@keyframes punch-in{
  0%{ opacity:0; transform:scale(.72); }
  55%{ opacity:1; transform:scale(1.1); }
  100%{ opacity:1; transform:scale(1); }
}
@keyframes punch-out{
  to{ opacity:0; transform:scale(.9); }
}

#beat.type-title.reveal{ animation:title-beat-in 2.6s cubic-bezier(.16,.7,.2,1) forwards; }
@keyframes title-beat-in{
  0%{
    opacity:0;
    transform:scale(.5);
    letter-spacing:.5em;
    filter:blur(18px);
  }
  55%{
    opacity:1;
    filter:blur(0);
  }
  100%{
    opacity:1;
    transform:scale(1);
    letter-spacing:.01em;
    filter:blur(0);
    text-shadow:0 0 30px rgba(200,57,44,.2), 0 0 3px rgba(232,225,210,.4);
  }
}

#beat.type-whisper.reveal{ animation:whisper-in 1.4s ease-out forwards; }
@keyframes whisper-in{
  from{ opacity:0; filter:blur(9px); letter-spacing:.32em; }
  to{ opacity:1; filter:blur(0); letter-spacing:.03em; }
}

/* ---------- door-shadow motif ---------- */

#door-shadow{
  position:fixed;
  left:50%;
  bottom:0;
  width:min(50vw, 420px);
  height:10px;
  transform:translateX(-50%) scaleX(.6);
  background:radial-gradient(ellipse at 50% 100%, rgba(0,0,0,.85), transparent 85%);
  opacity:0;
  transition:opacity .8s ease, transform .8s ease;
  z-index:4;
  pointer-events:none;
}
#door-shadow.show{ opacity:1; transform:translateX(-50%) scaleX(1); }
#door-shadow.face{
  height:26px;
  background:radial-gradient(ellipse at 50% 100%, rgba(0,0,0,.95) 0%, rgba(0,0,0,.7) 55%, transparent 90%);
}

/* ---------- phone notification ---------- */

#phone-notif{
  position:fixed;
  top:6vh;
  left:50%;
  transform:translate(-50%, -160%);
  z-index:11;
  width:min(86vw, 380px);
  display:flex;
  align-items:flex-start;
  gap:.7rem;
  background:rgba(20,17,15,.75);
  backdrop-filter:blur(14px);
  -webkit-backdrop-filter:blur(14px);
  border:1px solid rgba(232,225,210,.14);
  border-radius:16px;
  padding:.9rem 1.05rem;
  box-shadow:0 10px 30px rgba(0,0,0,.55);
  opacity:0;
  cursor:pointer;
  pointer-events:none;
  transition:transform .55s cubic-bezier(.2,.85,.25,1.25), opacity .4s ease;
}
#phone-notif.hidden{ display:none; }
#phone-notif.show{
  opacity:1;
  transform:translate(-50%, 0);
  pointer-events:auto;
  animation:notif-pulse 2.2s ease-in-out infinite;
}
#phone-notif.show.shake-in{
  animation:notif-shake .7s ease-in-out, notif-pulse 2.2s ease-in-out infinite .7s;
}
#phone-notif.show.nudge{
  animation:notif-shake .4s ease-in-out, notif-pulse 2.2s ease-in-out infinite;
}
#phone-notif.open{
  opacity:0;
  transform:translate(-50%, 0) scale(.94);
  transition:transform .3s ease, opacity .3s ease;
}
@keyframes notif-pulse{
  0%,100%{ box-shadow:0 10px 30px rgba(0,0,0,.55), 0 0 0 rgba(200,57,44,0); }
  50%{ box-shadow:0 10px 30px rgba(0,0,0,.55), 0 0 20px rgba(200,57,44,.22); }
}
@keyframes notif-shake{
  0%,100%{ transform:translate(-50%,0); }
  20%{ transform:translate(calc(-50% - 4px),0); }
  40%{ transform:translate(calc(-50% + 4px),0); }
  60%{ transform:translate(calc(-50% - 3px),0); }
  80%{ transform:translate(calc(-50% + 3px),0); }
}
#phone-notif .phone-notif-avatar{
  flex:none;
  width:34px; height:34px;
  border-radius:50%;
  background:radial-gradient(circle at 35% 30%, #2a2521, #0c0a09 75%);
  border:1px solid rgba(232,225,210,.12);
}
#phone-notif .phone-notif-text{ flex:1; min-width:0; }
#phone-notif .phone-notif-head{
  display:flex;
  align-items:baseline;
  justify-content:space-between;
  gap:.5rem;
  font-family:"Space Mono", monospace;
  font-size:.6rem;
  letter-spacing:.08em;
  text-transform:uppercase;
  color:var(--bone-faint);
  margin-bottom:.2rem;
}
#phone-notif .phone-notif-body{
  font-family:"Cormorant Garamond", Georgia, serif;
  font-size:1.05rem;
  color:var(--bone);
}
#phone-notif .phone-notif-sub{
  font-family:"Space Mono", monospace;
  font-size:.6rem;
  letter-spacing:.04em;
  color:var(--bone-dim);
  margin-top:.25rem;
}

/* ---------- image reveal ---------- */

#reveal-overlay{
  position:fixed;
  inset:0;
  z-index:8;
  display:flex;
  align-items:flex-end;
  justify-content:center;
  overflow:hidden;
  background:#000;
  opacity:0;
  pointer-events:none;
  transition:opacity .4s ease;
}
#reveal-overlay.hidden{ display:none; }
#reveal-overlay.show{
  opacity:1;
  pointer-events:auto;
}
#reveal-img{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  filter:blur(7px) brightness(.65);
  transform:scale(1.12);
  transition:filter 1s ease .1s, transform 1.5s cubic-bezier(.16,.7,.2,1) .1s;
}
#reveal-overlay.show #reveal-img{
  filter:blur(0) brightness(.94);
  transform:scale(1);
}
#reveal-vignette{
  position:absolute;
  inset:0;
  background:
    radial-gradient(ellipse 70% 65% at 50% 46%, transparent 30%, rgba(5,4,4,.5) 100%),
    linear-gradient(to top, rgba(5,4,4,.9) 0%, transparent 40%);
}
#reveal-caption{
  position:relative;
  z-index:1;
  margin:0 0 9vh;
  padding:0 6vw;
  font-family:"Cormorant Garamond", Georgia, serif;
  font-style:italic;
  font-size:clamp(1.3rem, 3vw, 1.9rem);
  color:var(--bone);
  text-shadow:0 2px 18px rgba(0,0,0,.9);
  text-align:center;
  text-wrap:balance;
  opacity:0;
  transition:opacity .8s ease .5s;
}
#reveal-overlay.show #reveal-caption{
  opacity:1;
  animation:text-tremble .15s steps(2) infinite;
  animation-delay:.9s;
}
@keyframes text-tremble{
  0%{ transform:translate(0,0) rotate(0deg); }
  10%{ transform:translate(-1px,1px) rotate(-.3deg); }
  20%{ transform:translate(1px,-1px) rotate(.3deg); }
  30%{ transform:translate(-1px,-1px) rotate(.2deg); }
  40%{ transform:translate(1.5px,1px) rotate(-.25deg); }
  50%{ transform:translate(-1px,0) rotate(.3deg); }
  60%{ transform:translate(1px,1px) rotate(-.3deg); }
  70%{ transform:translate(-1.5px,-1px) rotate(.2deg); }
  80%{ transform:translate(1px,-1px) rotate(-.2deg); }
  90%{ transform:translate(-1px,1px) rotate(.3deg); }
  100%{ transform:translate(0,0) rotate(0deg); }
}

/* ---------- computer UI takeover ---------- */

#computer-ui{
  position:fixed;
  inset:0;
  z-index:8;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:6vh 5vw;
  background:#020302;
  opacity:0;
  pointer-events:none;
  transition:opacity .35s ease;
}
#computer-ui.hidden{ display:none; }
#computer-ui.show{
  opacity:1;
  pointer-events:auto;
}
#computer-ui .cu-scan{
  position:absolute;
  inset:0;
  background:repeating-linear-gradient(
    to bottom,
    rgba(195,211,186,.06) 0px,
    rgba(195,211,186,.06) 1px,
    transparent 2px,
    transparent 4px
  );
  mix-blend-mode:overlay;
  pointer-events:none;
}
#computer-ui .cu-frame{
  position:relative;
  width:min(94vw, 920px);
  padding:3.6rem 2.4rem 3rem;
  border:1px solid rgba(195,211,186,.28);
  border-radius:3px;
  background:radial-gradient(ellipse at 50% 25%, rgba(195,211,186,.06), rgba(0,0,0,.92) 72%);
  box-shadow:0 0 70px rgba(195,211,186,.1), inset 0 0 50px rgba(0,0,0,.65);
}
#computer-ui .cu-topbar{
  position:absolute;
  top:0; left:0; right:0;
  display:flex;
  align-items:center;
  gap:.6rem;
  padding:.65rem 1.1rem;
  border-bottom:1px solid rgba(195,211,186,.16);
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.6rem;
  letter-spacing:.28em;
  text-transform:uppercase;
  color:var(--phosphor-dim);
}
#computer-ui .cu-dot{
  width:7px;
  height:7px;
  border-radius:50%;
  background:var(--ember-bright);
  box-shadow:0 0 8px 2px rgba(200,57,44,.7);
  animation:pulse-soft 1.6s ease-in-out infinite;
}
#computer-ui .cu-text{
  margin:0;
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:clamp(1.9rem, 6.4vw, 3.6rem);
  line-height:1.28;
  letter-spacing:.02em;
  color:var(--phosphor);
  text-align:center;
  text-wrap:balance;
  text-shadow:0 0 22px rgba(195,211,186,.6), 0 0 4px rgba(195,211,186,.9), 3px 0 rgba(200,57,44,.22), -3px 0 rgba(166,143,178,.18);
}
#computer-ui .cu-text .cursor{
  display:inline-block;
  width:.42em;
  margin-left:.05em;
  background:var(--phosphor);
  animation:blink 1s steps(1) infinite;
}

/* ---------- end screen ---------- */

#end{
  flex-direction:column;
  gap:2.4rem;
}
#end .eyes{
  display:flex;
  gap:2.4rem;
}
#end .eye{
  width:14px;
  height:8px;
  border-radius:50%;
  background:var(--ember-bright);
  box-shadow:0 0 18px 4px rgba(200,57,44,.65);
  animation:eye-breathe 3.4s ease-in-out infinite;
}
@keyframes eye-breathe{
  0%,100%{ opacity:.55; transform:scaleY(.7); }
  50%{ opacity:1; transform:scaleY(1); }
}
#end .replay{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.68rem;
  letter-spacing:.24em;
  text-transform:uppercase;
  color:var(--bone-faint);
  opacity:.55;
  cursor:pointer;
  background:none;
  border:none;
  padding:.6rem 1rem;
}
#end .replay:hover, #end .replay:focus-visible{ opacity:1; color:var(--bone-dim); }
#end .end-verdict{
  margin:0;
  font-family:"Cormorant Garamond", Georgia, serif;
  font-style:italic;
  font-size:clamp(1.4rem, 3.4vw, 2.1rem);
  color:var(--bone);
  text-align:center;
}
#end .end-detail{
  margin:0;
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.72rem;
  letter-spacing:.06em;
  color:var(--bone-faint);
  max-width:36ch;
  text-align:center;
  line-height:1.6;
}

/* ---------- enigma ---------- */

#enigma{
  flex-direction:column;
  gap:1.6rem;
  max-width:60ch;
}
#enigma .eyebrow{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.66rem;
  letter-spacing:.28em;
  text-transform:uppercase;
  color:var(--phosphor-dim);
}
#enigma .enigma-q{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:1.4rem;
}
#enigma .enigma-q.hide{ display:none; }
#enigma h2{
  margin:0;
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:clamp(1rem, 2.6vw, 1.35rem);
  letter-spacing:.02em;
  color:var(--phosphor);
  text-shadow:0 0 12px rgba(195,211,186,.4);
  text-align:center;
  max-width:32ch;
}
#enigma .enigma-options{
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
  gap:.7rem;
}
#enigma .opt{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.74rem;
  letter-spacing:.04em;
  color:var(--phosphor-dim);
  background:rgba(195,211,186,.04);
  border:1px solid rgba(195,211,186,.25);
  border-radius:2px;
  padding:.7rem 1.1rem;
  cursor:pointer;
  transition:border-color .2s ease, color .2s ease, background-color .2s ease;
}
#enigma .opt:hover:not(:disabled), #enigma .opt:focus-visible:not(:disabled){
  color:var(--phosphor);
  border-color:rgba(195,211,186,.55);
  background:rgba(195,211,186,.08);
}
#enigma .opt:disabled{ cursor:default; }
#enigma .opt.correct{
  color:var(--phosphor);
  border-color:var(--phosphor);
  background:rgba(195,211,186,.1);
}
#enigma .opt.wrong{
  color:var(--ember-bright);
  border-color:var(--ember-bright);
  background:rgba(200,57,44,.08);
}
#enigma .enigma-feedback{
  min-height:1.4em;
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.7rem;
  letter-spacing:.04em;
  color:var(--bone-faint);
  text-align:center;
}

/* ---------- controls ---------- */

#bpm-meter{
  position:fixed;
  top:1.4rem;
  left:1.4rem;
  z-index:10;
  display:flex;
  align-items:baseline;
  gap:.55rem;
  padding:.65rem 1rem;
  border-radius:24px;
  border:1px solid rgba(232,225,210,.14);
  background:rgba(10,8,7,.4);
  opacity:0;
  pointer-events:none;
  transition:opacity .5s ease;
}
#bpm-meter.show{ opacity:.75; }
#bpm-meter .bpm-pulse-dot{
  align-self:center;
  width:9px;
  height:9px;
  border-radius:50%;
  background:var(--ember-bright);
  box-shadow:0 0 8px 2px rgba(200,57,44,.65);
  animation:bpm-pulse var(--heartbeat-dur) ease-in-out infinite;
}
@keyframes bpm-pulse{
  0%,100%{ transform:scale(1); opacity:.6; }
  18%{ transform:scale(1.7); opacity:1; }
  36%{ transform:scale(1); opacity:.6; }
}
#bpm-meter #bpm-value{
  font-family:"Space Mono", ui-monospace, monospace;
  font-weight:700;
  font-size:1.4rem;
  letter-spacing:.02em;
  color:var(--bone);
  font-variant-numeric:tabular-nums;
  min-width:2.6ch;
  text-align:right;
  transition:color .4s ease;
}
body.panic #bpm-meter #bpm-value{ color:var(--ember-bright); }
body.calm #bpm-meter #bpm-value{ color:var(--phosphor-dim); }
#bpm-meter .bpm-label{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.72rem;
  font-weight:700;
  letter-spacing:.06em;
  text-transform:uppercase;
  color:var(--bone-dim);
}

#sound-toggle{
  position:fixed;
  top:1.4rem;
  right:1.4rem;
  z-index:10;
  width:2.4rem;
  height:2.4rem;
  border-radius:50%;
  border:1px solid rgba(232,225,210,.14);
  background:rgba(10,8,7,.4);
  color:var(--bone-faint);
  font-family:"Space Mono", monospace;
  font-size:.95rem;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  opacity:.55;
  transition:opacity .3s ease, border-color .3s ease;
}
#sound-toggle:hover, #sound-toggle:focus-visible{ opacity:1; border-color:rgba(232,225,210,.32); }

#pause-toggle{
  position:fixed;
  top:1.4rem;
  right:4.4rem;
  z-index:10;
  width:2.4rem;
  height:2.4rem;
  border-radius:50%;
  border:1px solid rgba(232,225,210,.14);
  background:rgba(10,8,7,.4);
  color:var(--bone-faint);
  font-family:"Space Mono", monospace;
  font-size:.85rem;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  opacity:0;
  pointer-events:none;
  transition:opacity .3s ease, border-color .3s ease;
}
#pause-toggle.show{ opacity:.55; pointer-events:auto; }
#pause-toggle.show:hover, #pause-toggle.show:focus-visible{ opacity:1; border-color:rgba(232,225,210,.32); }
#pause-toggle[aria-pressed="true"]{ color:var(--phosphor); border-color:rgba(195,211,186,.4); }

#pause-overlay{
  position:fixed; inset:0;
  z-index:12;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(2,2,2,.6);
  opacity:0;
  pointer-events:none;
  transition:opacity .3s ease;
}
body.paused #pause-overlay{ opacity:1; }
#pause-overlay .pause-label{
  font-family:"Space Mono", ui-monospace, monospace;
  font-size:.72rem;
  letter-spacing:.36em;
  text-transform:uppercase;
  color:var(--bone-dim);
}

#skip-toggle{
  position:fixed;
  top:1.4rem;
  right:7.4rem;
  z-index:10;
  width:2.4rem;
  height:2.4rem;
  border-radius:50%;
  border:1px solid rgba(232,225,210,.14);
  background:rgba(10,8,7,.4);
  color:var(--bone-faint);
  font-family:"Space Mono", monospace;
  font-size:.9rem;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  opacity:0;
  pointer-events:none;
  transition:opacity .3s ease, border-color .3s ease;
}
#skip-toggle.show{ opacity:.55; pointer-events:auto; }
#skip-toggle.show:hover, #skip-toggle.show:focus-visible{ opacity:1; border-color:rgba(232,225,210,.32); }
#skip-toggle[aria-pressed="true"]{ color:var(--phosphor); border-color:rgba(195,211,186,.4); }

#seek-bar{
  position:fixed;
  left:50%;
  bottom:2.6rem;
  transform:translateX(-50%) translateY(12px);
  z-index:7;
  width:min(70vw, 460px);
  height:1rem;
  display:flex;
  align-items:center;
  opacity:0;
  pointer-events:none;
  transition:opacity .3s ease, transform .3s ease;
}
#seek-bar::before{
  content:"";
  position:absolute;
  left:0; right:0;
  height:3px;
  border-radius:2px;
  background:rgba(232,225,210,.14);
}
#seek-bar.show{
  opacity:1;
  pointer-events:auto;
  transform:translateX(-50%) translateY(0);
}
#seek-fill{
  position:absolute;
  left:0;
  height:3px;
  width:0%;
  border-radius:2px;
  background:linear-gradient(to right, var(--ember), var(--ember-bright));
}
#seek-handle{
  position:absolute;
  left:0%;
  width:11px;
  height:11px;
  border-radius:50%;
  background:var(--bone);
  box-shadow:0 0 8px rgba(232,225,210,.5);
  transform:translateX(-50%);
}

#hint{
  position:fixed;
  bottom:1.2rem;
  left:50%;
  transform:translateX(-50%);
  z-index:6;
  font-family:"Space Mono", monospace;
  font-size:.62rem;
  letter-spacing:.16em;
  text-transform:uppercase;
  color:var(--bone-faint);
  opacity:0;
  transition:opacity 1s ease;
  pointer-events:none;
}
#hint.show{ opacity:.4; }

:focus-visible{ outline:1px solid var(--phosphor-dim); outline-offset:3px; }

@media (prefers-reduced-motion: reduce){
  #vignette{ animation:none; }
  #start h1{ animation:none; opacity:.92; transform:none; filter:none; letter-spacing:.01em; }
  #start .enter, #start .eyebrow, #start .cta{ animation:none; opacity:.7; }
  #start .meta{ animation:none; opacity:.75; }
  #start .start-actions{ animation:none; opacity:1; }
  #start .warn{ animation:none; opacity:.7; }
  #start .credits{ animation:none; opacity:.4; }
  #stage.shake{ animation:none; }
  #flash.go, #flash.go-white{ animation:none; opacity:0 !important; }
  #beat.reveal, #beat.dismiss, #beat.punch-in, #beat.punch-out, #beat.type-whisper.reveal, #beat.type-title.reveal{
    animation-duration:.01s !important;
  }
  #end .eye{ animation:none; opacity:.85; }
  #phone-notif.show, #phone-notif.show.shake-in, #phone-notif.show.nudge{ animation:none; }
  #reveal-overlay, #reveal-img, #reveal-caption{ transition-duration:.01s !important; }
  #computer-ui{ transition-duration:.01s !important; }
  #computer-ui .cu-dot{ animation:none; opacity:.7; }
  #reveal-overlay.show #reveal-caption{ animation:none; }
  body.panic #panic-tint{ animation:none; }
  #calm-wash, #vignette, #grain{ transition-duration:.01s !important; }
  #stage.panic-jitter, #stage.panic-jitter.shake{ animation:none; }
  #pause-overlay{ transition-duration:.01s !important; }
  #bpm-meter .bpm-pulse-dot{ animation:none; opacity:.8; }
}
</style>
